import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
 
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
const VARIANT_CONFIG = {
  'Back/Forward': {
    showBack: true,
    showForward: true,
  },
  'No Back/Forward': {
    showBack: false,
    showForward: true,
  },
  'Back/No Forward': {
    showBack: true,
    showForward: false,
  },
};

const BreadcrumbLine = ({
  variant = 'Back/Forward',
  onBack,
  onForward,
  ...props
}) => {
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG['Back/Forward'];
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: 'none',
        borderRadius: 0,
        px: 2,
        py: 1.5,
        mb: 2,
        backgroundColor: '#fff',
        minWidth: 420,
        minHeight: 40,
        gap: 2,
      }}
      {...props}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {config.showBack && (
          <Button
            startIcon={<KeyboardReturnIcon sx={{ color: '#7a2a6a' }} />}
            sx={{
              color: '#7a2a6a',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: 15,
              background: 'transparent',
              boxShadow: 'none',
              '&:hover': { background: 'rgba(122,42,106,0.06)' },
              px: 0,
              minWidth: 0,
            }}
            disableRipple
            onClick={onBack}
          >
            Back to search
          </Button>
        )}
      </Box>
      <Box sx={{ flex: 1 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {config.showForward && (
          <Button
            startIcon={<OpenInNewIcon sx={{ color: '#7a2a6a', fontSize: 18 }} />}
            sx={{
              color: '#7a2a6a',
              fontWeight: 500,
              textTransform: 'none',
              fontSize: 14,
              background: 'transparent',
              boxShadow: 'none',
              '&:hover': { background: 'rgba(122,42,106,0.06)' },
              px: 0,
              minWidth: 0,
            }}
            disableRipple
            onClick={onForward}
          >
            Open profile in new tab
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default BreadcrumbLine;
